import axios from "../config/axiosConfig";

export const registerUser = async (userData) => {
  try {
    const response = await axios.post("/users", userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
    // console/log("error", error)
  }
};

// Log in user
export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(`/auth/login`, credentials);
    // Store token or user info as needed
    console.log("login api ressss", response.data);
    if (response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
    }
    return response.data;
  } catch (error) {
    console.log("ERROR==>>", error);
  }
};

export const getUserProfile = async () => {
  try {
    const response = await axios.get("/auth/profile");
    return response.data;
  } catch (error) {
    // console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const uploadUserImage = async (formData) => {
  try {
    const response = await axios.post("/auth/upload-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

